// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box {
  width: calc(33.33% - 20px);
  height: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  margin-right: 20px;
  color: var(--dark2-color);
  margin-bottom: 30px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.box:last-child {
  margin-right: 0;
}
.content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 24px;
  gap: 10px;
  padding-bottom: 20px;
  color: var(--dark2-color);
  font-size: 50px;
  /* font-weight: 400; */
}

.usersSetting {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  cursor: pointer;
}

.btns {
  padding: 8px 12px;
  outline: none;
  border: none;
  border-radius: 5px;
  background-color: #aaa;
  color: #fff;
  cursor: pointer;
}

.btns.disabled {
  background-color: var(--icon-bg-color);
  cursor: not-allowed;
  color: var(--secondary-color);
}

.users {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 8px;
  color: var(--secondary-color);
}
.users h3 {
  color: var(--dark-color);
}
.snackbar {
  position: fixed;
  bottom: 60px;
  right: 30px;
  background-color: var(--icon2-bg-color);
  color: var(--secondary-color);
  padding: 15px 20px;
  border-radius: 8px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.greenTick {
  margin-right: 10px;
  color: green;
  font-size: 20px;
  margin-top: 10px;
}

.message {
  flex-grow: 1;
  font-size: 16px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); 
  z-index: 1; 
}

.popup-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 8px;
  z-index: 2; 
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  color: var(--text-color);
  font-size: 28px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: var(--icon-bg-color);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-container{
  width: 500px;
  height: 500px;
}

form {
  margin-top: 20px; 
  color: var(--dark-color);
}
/* 
label {
  display: block; 
  margin-bottom: 5px; 
  font-size: 16px;
} */


/* i comment this input css because it is impacting my login signup input css */
/* input[type="text"] {
  width: 100%; 
  padding: 12px; 
  font-size: 14px; 
  border: 1px solid #ccc; 
  border-radius: 4px; 
  margin-bottom: 20px;
  font-size: 16px;
}

input[type="text"]:focus {
  outline: none; 
  border-color: var(--secondary-color); 
} */

.btn{
  width: 100%;
  height: 48px;
  background-color: var(--secondary-color);
  color: var(--white-color);
  margin-top: 30px;
  border: none;
  outline: none;
  font-size: 18px;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Component/ReuseableComp/UserExperienCard.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;;;;GAKG;;;AAGH,+EAA+E;AAC/E;;;;;;;;;;;;;GAaG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".box {\n  width: calc(33.33% - 20px);\n  height: 200px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 12px;\n  margin-right: 20px;\n  color: var(--dark2-color);\n  margin-bottom: 30px;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n}\n.box:last-child {\n  margin-right: 0;\n}\n.content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 24px;\n  gap: 10px;\n  padding-bottom: 20px;\n  color: var(--dark2-color);\n  font-size: 50px;\n  /* font-weight: 400; */\n}\n\n.usersSetting {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.btns {\n  padding: 8px 12px;\n  outline: none;\n  border: none;\n  border-radius: 5px;\n  background-color: #aaa;\n  color: #fff;\n  cursor: pointer;\n}\n\n.btns.disabled {\n  background-color: var(--icon-bg-color);\n  cursor: not-allowed;\n  color: var(--secondary-color);\n}\n\n.users {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  padding-bottom: 8px;\n  color: var(--secondary-color);\n}\n.users h3 {\n  color: var(--dark-color);\n}\n.snackbar {\n  position: fixed;\n  bottom: 60px;\n  right: 30px;\n  background-color: var(--icon2-bg-color);\n  color: var(--secondary-color);\n  padding: 15px 20px;\n  border-radius: 8px;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.greenTick {\n  margin-right: 10px;\n  color: green;\n  font-size: 20px;\n  margin-top: 10px;\n}\n\n.message {\n  flex-grow: 1;\n  font-size: 16px;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); \n  z-index: 1; \n}\n\n.popup-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  border-radius: 8px;\n  z-index: 2; \n}\n\n.close-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  color: var(--text-color);\n  font-size: 28px;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background-color: var(--icon-bg-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.popup-container{\n  width: 500px;\n  height: 500px;\n}\n\nform {\n  margin-top: 20px; \n  color: var(--dark-color);\n}\n/* \nlabel {\n  display: block; \n  margin-bottom: 5px; \n  font-size: 16px;\n} */\n\n\n/* i comment this input css because it is impacting my login signup input css */\n/* input[type=\"text\"] {\n  width: 100%; \n  padding: 12px; \n  font-size: 14px; \n  border: 1px solid #ccc; \n  border-radius: 4px; \n  margin-bottom: 20px;\n  font-size: 16px;\n}\n\ninput[type=\"text\"]:focus {\n  outline: none; \n  border-color: var(--secondary-color); \n} */\n\n.btn{\n  width: 100%;\n  height: 48px;\n  background-color: var(--secondary-color);\n  color: var(--white-color);\n  margin-top: 30px;\n  border: none;\n  outline: none;\n  font-size: 18px;\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
